module.exports = __webpack_public_path__ + "img/call_silent.18be194b.svg";